class CardSizeSelector {
  constructor() {
    this.init();
  }

  init() {
    // Aguarda o DOM estar carregado
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.bindEvents());
    } else {
      this.bindEvents();
    }
  }

  bindEvents() {
    // Adiciona event listeners para todos os botões de tamanho
    document.addEventListener('click', (event) => {
      if (event.target.matches('.size-pill--available')) {
        this.handleSizeSelection(event);
      }
    });

    // Tooltip ao passar o mouse no botão desabilitado (funciona na área inteira do botão)
    document.addEventListener('mouseover', (event) => {
      const btn = event.target.closest('.card-add-to-cart-button');
      if (!btn) return;
      // Evita disparar quando movendo dentro do próprio botão
      if (btn.contains(event.relatedTarget)) return;
      if (btn.disabled) this.showDisabledTooltip(btn);
    }, true);

    document.addEventListener('mouseout', (event) => {
      const btn = event.target.closest('.card-add-to-cart-button');
      if (!btn) return;
      // Evita disparar quando movendo dentro do próprio botão
      if (btn.contains(event.relatedTarget)) return;
      this.hideDisabledTooltip(btn);
    }, true);

    // Ao clicar em botão desabilitado, evita ação e mostra tooltip
    document.addEventListener('click', (event) => {
      const btn = event.target.closest('.card-add-to-cart-button');
      if (!btn) return;
      if (btn.disabled) {
        event.preventDefault();
        event.stopPropagation();
        this.showDisabledTooltip(btn);
      }
    }, true);
  }

  handleSizeSelection(event) {
    const sizeButton = event.target;
    
    // Se for um link (mobile), permite o comportamento padrão
    if (sizeButton.tagName === 'A') {
      return; // Permite o redirecionamento do link
    }
    
    // Para botões (desktop), previne o comportamento padrão
    event.preventDefault();
    const variantId = sizeButton.getAttribute('data-variant-id');
    const size = sizeButton.getAttribute('data-size');
    
    // Encontra o card pai
    const cardContainer = sizeButton.closest('.card-wrapper') || sizeButton.closest('.card');
    if (!cardContainer) return;

    // Encontra a seção de add-to-cart dentro do mesmo card
    const addToCartSection = cardContainer.querySelector('.card-information__add-to-cart');
    if (!addToCartSection) return;

    // Remove seleção anterior de outros tamanhos no mesmo card
    const allSizePills = cardContainer.querySelectorAll('.size-pill--available');
    allSizePills.forEach(pill => {
      pill.classList.remove('size-pill--selected');
    });

    // Adiciona classe de selecionado ao tamanho atual
    sizeButton.classList.add('size-pill--selected');

    // Atualiza o input hidden com o variant ID
    const variantInput = addToCartSection.querySelector('.product-variant-id');
    const addButton = addToCartSection.querySelector('.card-add-to-cart-button');

    if (variantInput && addButton) {
      // Atualiza o variant ID
      variantInput.value = variantId;
      variantInput.disabled = false;

      // Habilita o botão e atualiza o texto
      addButton.disabled = false;

      // Remove classe de disabled se existir
      addButton.classList.remove('card-add-to-cart-button--disabled');

      // Remove tooltip se existir
      this.hideDisabledTooltip(addButton);
    }
  }

  showDisabledTooltip(btn) {
    // Evita duplicar tooltip
    if (btn._sizeTooltipEl) return;
    const tip = document.createElement('div');
    tip.className = 'size-select-tooltip';
    tip.textContent = 'Selecione um tamanho antes de adicionar';
    // Posicionamento necessário em inline (complementa o CSS)
    Object.assign(tip.style, {
      position: 'absolute',
      left: '50%'
    });

    // Garante que o botão tenha position relativo para posicionamento
    const prevPos = getComputedStyle(btn).position;
    if (prevPos === 'static') btn.style.position = 'relative';
    btn._prevPosStatic = prevPos === 'static';

    // Seta (arrow) do tooltip
    const arrow = document.createElement('div');
    arrow.className = 'size-select-tooltip__arrow';
    tip.appendChild(arrow);

    btn.appendChild(tip);
    btn._sizeTooltipEl = tip;
    // Fade in via classe de visibilidade
    requestAnimationFrame(() => {
      tip.classList.add('size-select-tooltip--visible');
    });
  }

  hideDisabledTooltip(btn) {
    if (btn && btn._sizeTooltipEl) {
      const tip = btn._sizeTooltipEl;
      tip.classList.remove('size-select-tooltip--visible');
      setTimeout(() => {
        if (tip && tip.parentNode) tip.parentNode.removeChild(tip);
      }, 200);
      btn._sizeTooltipEl = null;
      if (btn._prevPosStatic) {
        btn.style.position = '';
        btn._prevPosStatic = false;
      }
    }
  }
}

// Inicializa a funcionalidade quando o script é carregado
new CardSizeSelector();
